/* Parse a route file (.gpx or .geojson) in the browser into a GeoJSON
 * LineString, plus derived start/finish points.
 *
 * Returns { route, points, startPoint, finishPoint } or throws on bad input.
 */

function lineStringFromGeojson(obj) {
  // Collect all LineString geometries (FeatureCollection / Feature / bare),
  // pick the one with the most points (the route; ignore waypoint Points).
  const lines = [];
  const pushGeom = (g) => {
    if (!g) return;
    if (g.type === 'LineString' && Array.isArray(g.coordinates)) lines.push(g.coordinates);
    else if (g.type === 'MultiLineString') g.coordinates.forEach((c) => lines.push(c));
  };
  if (obj.type === 'FeatureCollection') (obj.features || []).forEach((f) => pushGeom(f.geometry));
  else if (obj.type === 'Feature') pushGeom(obj.geometry);
  else pushGeom(obj);
  if (!lines.length) return null;
  return lines.reduce((a, b) => (b.length > a.length ? b : a));
}

function coordsFromGpx(text) {
  const doc = new DOMParser().parseFromString(text, 'application/xml');
  if (doc.querySelector('parsererror')) throw new Error('GPX inválido (XML malformado)');
  const pts = Array.from(doc.querySelectorAll('trkpt, rtept'));
  const coords = [];
  for (const p of pts) {
    const lat = parseFloat(p.getAttribute('lat'));
    const lon = parseFloat(p.getAttribute('lon'));
    if (!isFinite(lat) || !isFinite(lon)) continue;
    const eleEl = p.querySelector('ele');
    const ele = eleEl ? parseFloat(eleEl.textContent) : null;
    coords.push(isFinite(ele) ? [lon, lat, ele] : [lon, lat]);
  }
  return coords;
}

export function parseRouteFile(text, filename) {
  const name = (filename || '').toLowerCase();
  let coords;
  if (name.endsWith('.geojson') || name.endsWith('.json') || text.trim().startsWith('{')) {
    const obj = JSON.parse(text);
    coords = lineStringFromGeojson(obj);
    if (!coords) throw new Error('Nenhuma LineString encontrada no GeoJSON');
  } else {
    coords = coordsFromGpx(text);
  }
  if (!coords || coords.length < 2) {
    throw new Error('O arquivo precisa ter uma trilha com pelo menos 2 pontos');
  }
  const route = { type: 'LineString', coordinates: coords };
  const startPoint = { type: 'Point', coordinates: [coords[0][0], coords[0][1]] };
  const finishPoint = { type: 'Point', coordinates: [coords[coords.length - 1][0], coords[coords.length - 1][1]] };
  return { route, points: coords.length, startPoint, finishPoint };
}
